import { render } from "./batchmanage.vue?vue&type=template&id=ce1b1c74"
import script from "./batchmanage.vue?vue&type=script&lang=js"
export * from "./batchmanage.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__